import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PageToastMessagesComponent } from 'Angular/features/components/toast-messages/page-toast-messages.component';
import { GlossaryTermComponent } from 'GlossaryApp/ts/apps/glossary-term-app/components/glossary-term/glossary-term.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [GlossaryTermComponent, TopBarNavComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        IconModule,
        IconSearchAutocompleteModule,
        NavigationModule,
        PageToastMessagesComponent,
        TooltipModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
